import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage, setTitle, getCategory, setSelectedCategory , pageLoaded} from '../fundialSlice';
import CategoriesList from '../Shared/CategoriesList/CategoriesList';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import Search from '../Shared/Search/search';


const CategoryPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    if (runSideEffects()) {
      props.setTitle({ titleBold: props.selectedCategory.title, titleRegular: "" })
      props.pageLoaded();
    }
  }, []);
 
  function handleOnClickCategory(categoryId, categoryTitle) {
      async function getCategory() {
        props.showAppLoader();
        var category = await props.getCategory(categoryId);
        props.hideAppLoader();
        if(category.payload.results.folders.length > 0){
          props.setSelectedCategory({id: categoryId, title: categoryTitle, page: "categoryPage" });
          props.goToPage({page: 'categoryPage'});
        }
        else if(category.payload.results.items.length > 0){
          props.setSelectedCategory({id: categoryId, title: categoryTitle, page: "songListPage" });
          props.goToPage({page: 'songListPage'});
        }  

    }
    getCategory();
  }

  function view(){
      return(<div>
                <Search></Search>
                {props.catagories[props.selectedCategory.id] && <CategoriesList onClickCategory={handleOnClickCategory} items={props.catagories[props.selectedCategory.id].folders} title={""} />}
            </div>)
  }


  return (
    <div className='category-page'>
      {view()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    catagories: state.fundialPage.catagories,
    selectedCategory: state.fundialPage.pages.categoryPage.selectedCategory,
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle, 
  getCategory, 
  setSelectedCategory,
  showAppLoader, 
  hideAppLoader,
  pageLoaded
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryPage);
